import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";
import Button from "../Nano/Buttons/Button.js";
import Type from "../Global/Typography.js";
import { ReactComponent as DeleteWarning } from "../Global/Icons/delete.svg";

const DeleteContentStyle = styled.div`
  padding: 24px;
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  .modalContainer {
    max-width: 350px;
    .modalTitle {
      padding: ${nota.global.multiple * 2 + "px"}; /*16px*/
      .modalIcon {
        width: 25px;
        height: 25px;
        margin-right: ${nota.global.multiple * 2 + "px"}; /*16px*/
        path {
          fill: ${nota.color.main.mTwo};
        }
      }
    }
    .infoContainer {
      padding: ${nota.global.multiple * 2 + "px"}; /*16px*/
      padding-top: 0;
      max-height: 500px;
      min-height: 100px;
      overflow: auto;
      text-align: center;
    }
    .btnsContainer {
      height: 50px;
      padding: ${nota.global.multiple * 2 + "px"}; /*16px*/
      padding-bottom: 0;
      margin: 0;
      border-top: 0.5px solid ${nota.color.neutral.NeuTwo};
    }
  }
  /* MEDIA QUERIES */
  @media only screen and (max-width: 520px) {
    width: 90vw;
    .listContainerModal {
      .itemContainerModal {
        padding: 8px;
        .userWrapper {
          width: calc(70vw - 24px);
          .userIconWrapper {
            width: 20px;
            height: 20px;
            padding: 12px;
            h3 {
              font-size: 12px;
            }
          }
          .userInfoWrapper {
            margin-left: 8px;
          }
        }
      }
    }
    .modalContainer {
      max-width: 100%;
      .btnsContainer {
        flex-direction: column;
        height: auto;
        padding-top: 0;
        .buttonWrapper {
          order: 1;
          .cta {
            margin-bottom: 0;
          }
        }
        .simpleButtonWrapper {
          order: 2;
          margin-top: 8px;
        }
      }
    }
  }
`;

class DeleteContent extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <DeleteContentStyle>
        <NanoFlex className="modalContainer" flexDirection={"column"} flexWrap={"wrap-reverse"} justifyContent={"space-around"} alignContent={"center"}>
          <NanoFlex className="modalTitle" justifyContent={"flex-start"} alignItems={"flex-end"}>
            <DeleteWarning className="modalIcon" />
            <Type.h2>{this.translation.geral.delete}</Type.h2>
          </NanoFlex>
          <NanoFlex className="infoContainer" flexDirection={"column"}>
            <Type.p>{this.translation.components.deleteContent.message}</Type.p>
            <Type.p>
              <b>"{this.props.field}"</b>?
            </Type.p>
          </NanoFlex>
          <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
            <Button label={this.translation.geral.cancel} simple clickAction={() => this.props.cancelAction()} />
            <Button label={this.translation.geral.confirm} clickAction={() => this.props.nextAction()} />
          </NanoFlex>
        </NanoFlex>
      </DeleteContentStyle>
    );
  }
}

// Set default props
DeleteContent.defaultProps = {
  field: "",
  cancelAction: () => null,
  nextAction: () => null,
};

export default DeleteContent;

/*
Doc
import DeleteContent from '../../Micro/DeleteContent.js';

<DeleteContent
    cancelAction={() => console.log('cancelAction')}
    nextAction={() => console.log('nextAction')}
/>
*/
